import React from 'react';
import classNames from 'classnames';

import { Accordion } from 'components';

import InvoiceThumbnail from '../../../Invoices/components/InvoiceThumbnail';

import shared from 'styles/custom/Shared.module.scss';

const Invoices = ({ invoices = [], supplierId, suborderUid }) => {
  const title = <h3 className={classNames(shared.tableCategoryTitle, shared.large, shared.noPadding)}>Faktura</h3>;

  if (invoices.length === 0) {
    return null;
  }

  return (
    <Accordion
      section
      title={title}
      extraDeps={[invoices]}
    >
      {invoices.map((invoice) => (
        <InvoiceThumbnail
          suborder_uid={suborderUid}
          supplier_id={supplierId}
          key={invoice.file_name}
          order_public_id
          item={invoice}
          inOrderView
          forSupplier
          {...invoice}
        />
      ))}
    </Accordion>
  );
};

export default Invoices;
